<div class="related-notes">
  <!-- Total Acredited Card -->
  <div class="related-notes__total-card">
    <span class="related-notes__total-label">{{
      'global.notes.total-accredited' | translate
    }}</span>
    <span class="related-notes__total-value">{{
      formatCurrency(totalAccredited() ?? 0)
    }}</span>
  </div>

  <div class="related-notes__divider"></div>

  <!-- Notes Section Card -->
  <div class="related-notes__notes-card">
    <!-- Search Filter -->
    <div class="related-notes__search">
      <v-one-search
        [placeholder]="'global.notes.search' | translate"
        (searchChange)="onSearchChange($event)"
      />
    </div>

    <!-- Notes List -->
    <div class="related-notes__list">
      @for (note of filteredNotes(); track note.id_nota) {
        <a
          class="related-notes__item"
          [routerLink]="['/details_notas', note.id_nota, companyId()]"
          target="_self"
          rel="noopener noreferrer"
        >
          <div class="related-notes__item-main">
            <div class="related-notes__item-header">
              <span class="related-notes__item-number">{{
                getNoteNumber(note)
              }}</span>
              <span
                class="related-notes__item-amount related-notes__item-amount--mobile"
              >
                {{ formatCurrency(note.total) }}
              </span>
            </div>
            <div class="related-notes__item-details">
              <span class="related-notes__item-date">{{
                formatDate(note.createAt || note.dueDate)
              }}</span>
              <span class="related-notes__item-separator">•</span>
              <span class="related-notes__item-concept">{{
                note.concepto
              }}</span>
            </div>
          </div>
          <div
            class="related-notes__item-amount related-notes__item-amount--desktop"
          >
            {{ formatCurrency(note.total) }}
          </div>
        </a>
      } @empty {
        <div class="related-notes__empty">
          {{ 'global.notes.no-related-notes' | translate }}
        </div>
      }
    </div>
  </div>
</div>
